import { app, pairApp } from "@/utils/firebase";
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithCustomToken,
  signInWithPopup,
} from "@/utils/firebase/auth";
import { ReactUtils } from "@/utils/react";

import { user } from "./user";

export const getIdTokenFromCustomToken = async (
  customToken: string,
): Promise<string> => {
  const userCredential = await signInWithCustomToken(
    getAuth(pairApp),
    customToken,
  );

  return await userCredential.user.getIdToken();
};

export const getIdTokenForGoogleProvider = async (): Promise<string> => {
  const result = await signInWithPopup(user.auth, new GoogleAuthProvider());
  return await result.user.getIdToken();
};

export const getIdTokenForMicrosoftProvider = async (): Promise<string> => {
  const provider = new OAuthProvider("microsoft.com");
  const result = await signInWithPopup(user.auth, provider);

  const credential = OAuthProvider.credentialFromResult(result);
  return credential?.idToken as string;
};

export function fetchToken() {
  const auth = getAuth(app);
  return ReactUtils.createSuspender(
    auth.authStateReady().then(() => auth.currentUser?.getIdToken()),
  );
}
